"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
exports.default = legacy_1.action('toggleCharm')(legacy_1.select({
    store: function () { return store_1.store; },
})(function toggleCharm(charm, state) {
    if (state.store.activeCharm === charm) {
        state.store.activeCharm = null;
    }
    else {
        state.store.activeCharm = charm;
    }
}));
//# sourceMappingURL=toggleCharm.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-store/lib/actions/toggleCharm.js
// module id = 1626
// module chunks = 2 87 105 106 107